import { render, staticRenderFns } from "./StaticTextConf.vue?vue&type=template&id=e99a0a5e"
import script from "./StaticTextConf.vue?vue&type=script&lang=js"
export * from "./StaticTextConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports